import React, { useEffect, useState } from 'react';
import { getRequest } from '../../utils/apiCall';
import { Col, Row, Spinner } from 'reactstrap';
import FeedbackCard from './FeedbackCard';
// import { useSearchParams } from 'react-router-dom';
import PaginationComponent from '../Pagination/PaginationComponent';

const FEEDBACK_URL = 'api/v1/feedback';

export default function FeedbackList({userId,deleteBtn}) {
    // const [searchParams, setSearchParams] = useSearchParams();

    const [isLoading, setIsLoading] = useState(false);
    const [feedbackList, setFeedbackList] = useState([]);
    const [metaData, setMetaData] = useState();
    const [currentPage, setCurrentPage] = useState();

    const callFeedbackList = async () => {
        setIsLoading(true);
  
        try {
            const response = await getRequest(FEEDBACK_URL,{
                params: {
                    user_id: userId,
                    page:currentPage && currentPage,
                }
            });
            setFeedbackList(response.data.data);
            setMetaData(response.data.meta);
            setCurrentPage(response.data.meta?.current_page);
            setIsLoading(false);
        } 
        catch (error) {
            setIsLoading(false);
        }
      }

    useEffect(() => {
        callFeedbackList();
    },[]);

    useEffect(() => {
        // currentPage &&
        //   searchParams.set('page', currentPage);
        //   setSearchParams(searchParams);
          callFeedbackList();
    },[currentPage]);
      
  return (
    <>
        {isLoading 
            ? <div className='text-center'>
                <Spinner color='primary' className='mx-auto'>
                    Loading...
                </Spinner>
              </div>
            : feedbackList.length > 0
                ? <>
                    <Row>
                    {
                        feedbackList.map((feedback) => (
                            <Col key={feedback.id} xs={12}>
                                <FeedbackCard userId={userId} feedback={feedback} deleteBtn={deleteBtn} onCallFeedbackList={callFeedbackList} />
                            </Col>
                        ))
                    }
                    </Row>
                    <Row>
                        <Col>
                            {
                                metaData &&
                                metaData.last_page > 1 
                                    ? (
                                    <PaginationComponent currentPage={currentPage} setCurrentPage={setCurrentPage}  metaData={metaData}/>
                                    ) 
                                    : ('')
                            }   
                        </Col>
                    </Row>
                  </>
                : <p className="fw-bold py-4">No Feedback to display</p>
        }
    </>
  )
}
